import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design } from '../ConditionQueries/components';
import useConditionQueries from './useConditionQueries';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const ConditionQueryDesign = props => {
  const template = useConditionQueries();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Design
          template={template}
          showNav={true}
          back="/condition-queries/details"
        />
      </div>
    </div>
  );
};

export default ConditionQueryDesign;